module.exports = __webpack_public_path__ + "img/13.0ec9250c.jpg";